import axios from "axios";
import axiosCancel from "axios-cancel";
import store from "@/store";

let api_base_uri = () => {
  switch (document.location.host) {
    case "localhost:8080":
    case "localhost:8081":
      return "https://localhost:5001/";
      //return "https://parked-partners-webapi.azurewebsites.net/";
    case "staging-partners.joinparked.com":
      return "https://parked-partners-stg-webapi.azurewebsites.net/";
    default:
      return "https://parked-partners-webapi.azurewebsites.net/";
    //return "https://parked-partners-stg-webapi.azurewebsites.net/";
    //return "https://ownli-partner-dev-api.azurewebsites.net/";
  }
};

let config = {
  baseURL: api_base_uri(),
  timeout: process.env.NODE_ENV === "production" ? 60 * 1000 : 300 * 1000,
};

const _axios = axios.create(config);

axiosCancel(_axios, {
  debug: false,
});

_axios.interceptors.request.use(
  async (config) => {
    // Do something before request is sent
    const token = await store.dispatch("auth/getTokenSilently");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },

  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    // console.log("_axios.interceptors.response:", error)
    if (error["__CANCEL__"] != true) {
      return Promise.reject(error);
    }
  }
);

export default _axios;
